// B2B / Přehled (schválený mockup 1). Ve fázi 2 jen skutečná čísla z CRM a karta Firmy podle stavu.
// Dlaždice s akcemi, nabídkami, tržbami a provizemi přibudou s fázemi 3 až 8.
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Building2, Plus, RefreshCw } from "lucide-react";
import GradientHeader from "../../components/GradientHeader.jsx";
import { Stranka, Dlazdice, RozbalovaciVyber, ErrorNote, Hlaska } from "../../components/ui.jsx";
import Card from "../../components/Card.jsx";
import { b2bGet } from "../../components/b2b/b2bApi.js";
import { StavPil, STAVY, krokPil } from "../../components/b2b/b2bUi.jsx";
import { Pil } from "../../components/sales/salesUi.jsx";
import { useUzkaObrazovka } from "../../lib/obrazovka.js";

const POKRACUJICI = ["k_osloveni", "osloveno", "followup", "zajem", "schuzka", "nabidka", "klient"];

export default function Prehled() {
  const navigate = useNavigate();
  const uzka = useUzkaObrazovka();
  const [data, setData] = useState(null);
  const [chyba, setChyba] = useState("");
  const [vybrany, setVybrany] = useState("zajem");
  const [firmyStavu, setFirmyStavu] = useState([]);

  const nacti = useCallback(async () => {
    try { setData(await b2bGet("prehled")); setChyba(""); } catch (e) { setChyba(e.message); }
  }, []);
  useEffect(() => { nacti(); }, [nacti]);

  // Na telefonu se po výběru stavu načtou firmy tohoto stavu.
  useEffect(() => {
    if (!uzka) return;
    b2bGet("firmy", { stav: vybrany }).then((r) => setFirmyStavu(r.firmy || [])).catch(() => setFirmyStavu([]));
  }, [uzka, vybrany, data]);

  const s = data?.stavy || {};
  const pocty = POKRACUJICI.map((k) => [k, s[k] || 0]);
  const celkem = Object.values(s).reduce((n, x) => n + x, 0);
  const vJednani = (s.zajem || 0) + (s.schuzka || 0) + (s.nabidka || 0);
  const akce = [
    { klic: "firma", ikona: Plus, popis: "Nová firma", onClick: () => navigate("/b2b/firmy?nova=1") },
    { klic: "obnovit", ikona: RefreshCw, popis: "Obnovit", onClick: nacti },
  ];

  return (
    <Stranka>
      <GradientHeader title="B2B" icon={Building2} akce={akce} />
      {chyba && <ErrorNote onRetry={nacti}>{chyba}</ErrorNote>}
      <div className="grid grid-cols-2 gap-2 sm:gap-3 lg:grid-cols-4">
        <Dlazdice popisek="Firem v CRM" hodnota={data ? String(celkem) : "..."} ton="znacka" />
        <Dlazdice popisek="K oslovení" hodnota={data ? String(s.k_osloveni || 0) : "..."} ton="info" />
        <Dlazdice popisek="V jednání" hodnota={data ? String(vJednani) : "..."} ton="ok" doplnky={<Pil ton="neutralni" mala casti="zájem, schůzka, nabídka" />} />
        <Dlazdice popisek="Klienti" hodnota={data ? String(s.klient || 0) : "..."} ton="pozor" />
      </div>
      <Hlaska ton="pozor" title="Přehled se plní postupně">Akce, nabídky, tržby a provize se tu objeví s dalšími fázemi. Zatím je k dispozici CRM firem.</Hlaska>

      <Card title="Firmy podle stavu" ikona={Building2} action={<button type="button" className="btn-secondary btn-sm" onClick={() => navigate("/b2b/firmy")}>Všechny firmy</button>}>
        {!uzka ? (
          <div className="flex flex-wrap gap-2">
            {pocty.map(([k, n]) => (
              <button key={k} type="button" onClick={() => navigate(`/b2b/firmy`)} className="inline-flex min-h-[44px] items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2">
                <StavPil stav={k} />
                <span className="text-lg font-bold tabular-nums text-slate-900">{n}</span>
              </button>
            ))}
          </div>
        ) : (
          <div className="grid gap-3">
            <RozbalovaciVyber stitek="Stav" aria-label="Stav firem" value={vybrany} onChange={setVybrany}
              items={pocty.map(([k, n]) => ({ key: k, label: `${STAVY[k].label} (${n})` }))} />
            <div className="divide-y divide-slate-100 rounded-xl border border-slate-200 bg-white">
              {firmyStavu.length === 0 && <div className="px-4 py-3 text-sm text-slate-500">V tomhle stavu teď nic není.</div>}
              {firmyStavu.map((f) => {
                const k = krokPil(f);
                return (
                  <button key={f.id} type="button" onClick={() => navigate(`/b2b/firma/${f.id}`)} className="flex min-h-[44px] w-full flex-col items-start gap-0.5 px-4 py-2.5 text-left hover:bg-slate-50">
                    <span className="font-semibold text-slate-900">{f.nazev}</span>
                    <span className="text-sm text-slate-500">{[f.dalsi_krok, k?.text].filter(Boolean).join(", ") || "bez dalšího kroku"}</span>
                  </button>
                );
              })}
            </div>
          </div>
        )}
      </Card>
    </Stranka>
  );
}
